import { datadogLogsPlugin } from './datadog-logs';

export default datadogLogsPlugin;
